import script from "./userCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./userCenter.vue?vue&type=script&setup=true&lang=js"

import "./userCenter.vue?vue&type=style&index=0&id=e868a296&lang=less"
import "./userCenter.vue?vue&type=style&index=1&id=e868a296&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e868a296"]])

export default __exports__